import React, {
  useMemo,
  useState,
  useCallback,
} from 'react'

import {
  Button,
} from '@usap/uicomponents'

import { usePopUpContext } from '../../../../../providers/PopUpProvider'

const ChangeShippingAddressOnPaypal = () => {
  const {
    shouldShowCannotShipProducts,
  } = usePopUpContext()

  const [isProcessing, setIsProcessing] = useState(false)

  const buttonLabel = useMemo(
    () => {
      if (isProcessing) return 'Closing window...'
      return 'Change Shipping Address on Paypal'
    },
    [isProcessing],
  )

  const handleAction = useCallback(
    () => {
      setIsProcessing(false)
      shouldShowCannotShipProducts(false)
    },
    [setIsProcessing, shouldShowCannotShipProducts],
  )

  return (
    <Button
      custom
      hideBorder={false}
      disabled={isProcessing}
      label={buttonLabel}
      onClick={handleAction}
    />
  )
}

export default ChangeShippingAddressOnPaypal
